/** Class used to set the amount of products available in the price filter. */

export class QuantityByValues {

    /** Number of products from the first price. */
    public firstValue: number;

    /** Number of products from the second price. */
    public secondValue: number;

    /** Number of products from the third price. */
    public thirtyValue: number;

    /** Quantity of products in the fourth price. */
    public fourthValue: number;

    constructor(
        firstValue: number = 0,
        secondValue: number = 0,
        thirtyValue: number = 0,
        fourthValue: number = 0
    ) {
        this.firstValue = firstValue;
        this.secondValue = secondValue;
        this.thirtyValue = thirtyValue;
        this.fourthValue = fourthValue;
    }
}